import type { RouteRecordRaw } from 'vue-router'

// 路由配置
export const rawRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    component: () => import('@/views/(public)/layout.vue'),
    children: [
      {
        path: '',
        name: '(public).home',
        redirect: (to) => ({ name: '(public).dashboard', query: to.query }),
        meta: { hideInMenu: true },
      },
      // 仪表板
      {
        path: 'dashboard',
        name: '(public).dashboard',
        component: () => import('@/views/(public)/dashboard/page.vue'),
        meta: {},
      },
      // 账户管理
      {
        path: 'account',
        name: '(public).account',
        children: [
          {
            path: '',
            name: '(public).account.home',
            component: () => import('@/views/(public)/account/page.vue'),
            meta: {},
          },
        ],
      },
      // 存款
      {
        path: 'deposit',
        name: '(public).deposit',
        children: [
          {
            path: '',
            name: '(public).deposit.home',
            component: () => import('@/views/(public)/deposit/page.vue'),
            meta: {},
          },
          {
            path: 'pay',
            name: '(public).deposit.pay',
            component: () => import('@/views/(public)/deposit/pay/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 提款
      {
        path: 'withdraw',
        name: '(public).withdraw',
        redirect: '/withdraw',
        children: [
          {
            path: '',
            name: '(public).withdraw.home',
            component: () => import('@/views/(public)/withdraw/page.vue'),
            meta: {},
          },
        ],
      },
      // 转账
      {
        path: 'transfer',
        name: '(public).transfer',
        component: () => import('@/views/(public)/transfer/page.vue'),
        meta: {},
      },
      // 资金详情
      {
        path: 'fund-details',
        name: '(public).fund-details',
        component: () => import('@/views/(public)/fund-details/page.vue'),
        meta: {},
      },
      // 交易报告
      {
        path: 'transaction-reports',
        name: '(public).transaction-reports',
        redirect: '/transaction-reports/home',
        children: [
          {
            path: 'home',
            name: '(public).transaction-reports.home',
            component: () => import('@/views/(public)/transaction-reports/page.vue'),
            meta: {},
          },
          {
            path: 'detail/:loginid/:server_id',
            name: '(public).transaction-reports.detail',
            component: () => import('@/views/(public)/transaction-reports/detail/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 档案
      {
        path: 'files',
        name: '(public).files',
        component: () => import('@/views/(public)/files/page.vue'),
        meta: {},
      },
      // 下载
      {
        path: 'download',
        name: '(public).download',
        component: () => import('@/views/(public)/download/page.vue'),
        meta: {},
      },
      // 工单
      {
        path: 'work-orders',
        name: '(public).work-orders',
        children: [
          {
            path: '',
            name: '(public).work-orders.home',
            component: () => import('@/views/(public)/work-orders/page.vue'),
          },
          {
            path: 'create',
            name: '(public).work-orders.create',
            component: () => import('@/views/(public)/work-orders/create/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
          {
            path: 'detail',
            name: '(public).work-orders.detail',
            component: () => import('@/views/(public)/work-orders/detail/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
          {
            path: 'reply',
            name: '(public).work-orders.reply',
            component: () => import('@/views/(public)/work-orders/reply/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 通知
      {
        path: 'notifications',
        name: '(public).notifications',
        children: [
          {
            path: '',
            name: '(public).notifications.home',
            component: () => import('@/views/(public)/notifications/page.vue'),
          },
          {
            path: 'detail',
            name: '(public).notifications.detail',
            component: () => import('@/views/(public)/notifications/detail/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 活动
      {
        path: 'activities',
        name: '(public).activities',
        children: [
          {
            path: '',
            name: '(public).activities.home',
            component: () => import('@/views/(public)/activities/page.vue'),
          },
          {
            path: 'detail',
            name: '(public).activities.detail',
            component: () => import('@/views/(public)/activities/detail/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 课程路由组
      {
        path: 'course',
        name: '(public).course',
        children: [
          {
            path: '',
            name: '(public).course.home',
            component: () => import('@/views/(public)/course/page.vue'),
          },
          {
            path: 'living-bar-detail',
            name: '(public).course.living-bar.detail',
            component: () => import('@/views/(public)/course/living-bar/detail/page.vue'),
            meta: { hiddenInMenu: true },
          },
          {
            path: 'video-detail',
            name: '(public).course.video.detail',
            component: () => import('@/views/(public)/course/video/detail/page.vue'),
            meta: { hiddenInMenu: true },
          },
          {
            path: 'video-play',
            name: '(public).course.video.play',
            component: () => import('@/views/(public)/course/video/play-video/page.vue'),
            meta: { hiddenInMenu: true },
          },
        ],
      },
      // 积分
      {
        path: 'points',
        name: '(public).points',
        component: () => import('@/views/(public)/points/page.vue'),
        meta: {
          hiddenInMenu: true,
        },
      },
      // 合同管理
      {
        path: 'contract-management',
        name: '(public).contract-management',
        redirect: '/contract-management/home',
        children: [
          {
            path: 'home',
            name: '(public).contract-management.home',
            component: () => import('@/views/(public)/contract-management/page.vue'),
          },
          {
            path: 'ib',
            name: '(public).contract-management.ib',
            component: () => import('@/views/(public)/contract-management/ib/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
          {
            path: 'view',
            name: '(public).contract-management.view',
            component: () => import('@/views/(public)/contract-management/view/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 分享
      {
        path: 'share',
        name: '(public).share',
        children: [
          {
            path: '',
            name: '(public).share.home',
            component: () => import('@/views/(public)/share/page.vue'),
            meta: {},
          },
          {
            path: 'detail',
            name: '(public).share.detail',
            component: () => import('@/views/(public)/share/detail/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 设置
      {
        path: 'settings',
        name: '(public).settings',
        children: [
          {
            path: '',
            name: '(public).settings.home',
            component: () => import('@/views/(public)/settings/page.vue'),
            meta: {},
          },
          {
            path: 'security-center',
            name: '(public).settings.security-center',
            redirect: (to) => ({
              path: '/settings',
              query: { tab: 'security-center', ...to.query },
            }),
            children: [
              {
                path: '',
                name: '(public).settings.security-center.home',
                redirect: (to) => ({
                  path: '/settings',
                  query: { tab: 'security-center', ...to.query },
                }),
                meta: { hiddenInMenu: true },
              },
              {
                path: 'passkey',
                name: '(public).settings.passkey',
                component: () => import('@/views/(public)/settings/passkey/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
              {
                path: 'authenticator',
                name: '(public).settings.authenticator',
                component: () => import('@/views/(public)/settings/authenticator/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
              {
                path: 'device-manage',
                name: '(public).settings.security-center.device-manage',
                component: () => import('@/views/(public)/settings/device-manage/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
              {
                path: 'logs',
                name: '(public).settings.security-center.logs',
                component: () => import('@/views/(public)/settings/logs/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
            ],
          },
          {
            path: 'IB-signature',
            name: '(public).settings.IB-signature',
            component: () => import('@/views/(public)/settings/IB-signature/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
        ],
      },
      // 分析
      {
        path: 'analysis',
        name: '(public).analysis',
        component: () => import('@/views/(public)/analysis/page.vue'),
        meta: {
          hiddenInMenu: true,
        },
      },
      // 跟单
      {
        path: 'copy-trading',
        name: 'CopyTrading',
        component: () => import('@/views/(public)/copy-trading/layout.vue'),
        meta: {
          hiddenInMenu: true,
        },
        redirect: '/copy-trading/gtc-copy',
        children: [
          {
            path: 'gtc-copy',
            name: 'GtcCopy',
            redirect: '/copy-trading/gtc-copy/discover-signals',
            component: () => import('@/views/(public)/copy-trading/gtc-copy/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
            children: [
              {
                path: 'discover-signals',
                name: 'GtcCopyDiscoverSignals',
                component: () =>
                  import('@/views/(public)/copy-trading/gtc-copy/discover-signals/page.vue'),
                meta: {
                  topName: 'GtcCopy',
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'signal-details',
                    name: 'GtcCopyDiscoverSignalsDetails',
                    meta: {
                      topName: 'GtcCopyDiscoverSignals',
                    },
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/signal-details/page.vue'),
                  },
                ],
              },
              {
                path: 'all-signal',
                name: 'GtcCopyAllSignal',
                component: () =>
                  import('@/views/(public)/copy-trading/gtc-copy/all-signal/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'signal-details',
                    name: 'GtcCopyAllSignalDetails',
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/signal-details/page.vue'),
                  },
                ],
              },
              {
                path: 'assets',
                name: 'GtcCopyAssets',
                meta: {
                  topName: 'GtcCopy',
                  hiddenInMenu: true,
                },
                component: () => import('@/views/(public)/copy-trading/gtc-copy/assets/page.vue'),
                children: [
                  {
                    path: 'assets-details',
                    name: 'GtcCopyAssetsDetails',
                    meta: {
                      topName: 'GtcCopyAssets',
                    },
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/assets-details/page.vue'),
                  },
                ],
              },
              {
                path: 'my-publish',
                name: 'GtcCopyMyPublish',
                meta: {
                  topName: 'GtcCopy',
                  hiddenInMenu: true,
                },
                component: () =>
                  import('@/views/(public)/copy-trading/gtc-copy/my-publish/page.vue'),
                children: [
                  {
                    path: 'create-signals',
                    name: 'GtcCopyMyPublishCreateSignals',
                    meta: {
                      topName: 'GtcCopyMyPublish',
                      hiddenInMenu: true,
                    },
                    component: () =>
                      import(
                        '@/views/(public)/copy-trading/gtc-copy/my-publish/create-signals/page.vue'
                      ),
                  },
                  {
                    path: 'publish-details',
                    name: 'GtcCopyMyPublisDetails',
                    meta: {
                      topName: 'GtcCopyMyPublish',
                      hiddenInMenu: true,
                    },
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/signal-details/page.vue'),
                  },
                  {
                    path: 'signal-report',
                    name: 'GtcCopyMyPublisReport',
                    meta: {
                      topName: 'GtcCopyMyPublish',
                      hiddenInMenu: true,
                    },
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/signal-report/page.vue'),
                  },
                ],
              },
              {
                path: 'my-share',
                name: 'GtcCopyMyShare',
                component: () => import('@/views/(public)/copy-trading/gtc-copy/my-share/page.vue'),
                meta: {
                  hiddenInMenu: true,
                  topName: 'GtcCopy',
                },
                children: [
                  {
                    path: 'share-details',
                    name: 'GtcCopyShareDetails',
                    meta: {
                      topName: 'GtcCopyMyShare',
                    },
                    component: () =>
                      import('@/views/(public)/copy-trading/gtc-copy/share-details/page.vue'),
                  },
                ],
              },
            ],
          },
          {
            path: 'in-platform-copy',
            name: 'InPlatformCopy',
            meta: {
              topName: 'InPlatformCopy',
              hiddenInMenu: true,
            },
            component: () => import('@/views/(public)/copy-trading/in-platform-copy/page.vue'),
            children: [
              {
                path: 'signal-details',
                name: 'InPlatformCopySignalDetails',
                component: () =>
                  import('@/views/(public)/copy-trading/in-platform-copy/signal-details/page.vue'),
                meta: {
                  topName: 'InPlatformCopySignalDetails',
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'start-copy',
                    name: 'InPlatformCopyStartCopy',
                    component: () =>
                      import('@/views/(public)/copy-trading/in-platform-copy/start-copy/page.vue'),
                    meta: {
                      topName: 'InPlatformCopySignalDetails',
                      hiddenInMenu: true,
                    },
                  },
                ],
              },
              {
                path: 'assets',
                name: 'InPlatformCopyAssets',
                component: () =>
                  import('@/views/(public)/copy-trading/in-platform-copy/assets/page.vue'),
                meta: {
                  topName: 'InPlatformCopyAssets',
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'share-details',
                    name: 'InPlatformCopyMyPublishDetails',
                    component: () =>
                      import(
                        '@/views/(public)/copy-trading/in-platform-copy/share-details/page.vue'
                      ),
                    meta: {
                      topName: 'InPlatformCopyMyPublish',
                      hiddenInMenu: true,
                    },
                  },
                ],
              },
              {
                path: 'create-signals',
                name: 'InPlatformCopyCreateSignals',
                component: () =>
                  import('@/views/(public)/copy-trading/in-platform-copy/create-signals/page.vue'),
                meta: {
                  topName: 'InPlatformCopyCreateSignals',
                  hiddenInMenu: true,
                },
              },
              {
                path: 'my-publish',
                name: 'InPlatformCopyMyPublish',
                component: () =>
                  import('@/views/(public)/copy-trading/in-platform-copy/my-publish/page.vue'),
                meta: {
                  topName: 'InPlatformCopyMyPublish',
                  hiddenInMenu: true,
                },
              },
            ],
          },
          {
            path: 'out-platform-copy',
            name: 'OutPlatformCopy',
            meta: {
              topName: 'OutPlatformCopy',
              hiddenInMenu: true,
            },
            component: () => import('@/views/(public)/copy-trading/out-platform-copy/page.vue'),

            children: [
              {
                path: 'signal-details',
                name: 'OutPlatformCopySignalDetails',
                component: () =>
                  import('@/views/(public)/copy-trading/out-platform-copy/signal-details/page.vue'),
                meta: {
                  topName: 'OutPlatformCopySignalDetails',
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'start-copy',
                    name: 'OutPlatformCopyStartCopy',
                    component: () =>
                      import('@/views/(public)/copy-trading/out-platform-copy/start-copy/page.vue'),
                    meta: {
                      topName: 'OutPlatformCopySignalDetails',
                      hiddenInMenu: true,
                    },
                  },
                ],
              },
              {
                path: 'assets',
                name: 'OutPlatformCopyAssets',
                component: () =>
                  import('@/views/(public)/copy-trading/out-platform-copy/assets/page.vue'),
                meta: {
                  topName: 'OutPlatformCopyAssets',
                  hiddenInMenu: true,
                },
                children: [
                  {
                    path: 'share-details',
                    name: 'OutPlatformCopyMyPublishDetails',
                    component: () =>
                      import(
                        '@/views/(public)/copy-trading/out-platform-copy/share-details/page.vue'
                      ),
                    meta: {
                      topName: 'OutPlatformCopyMyPublish',
                      hiddenInMenu: true,
                    },
                  },
                ],
              },
              {
                path: 'create-signals',
                name: 'OutPlatformCopyCreateSignals',
                component: () =>
                  import('@/views/(public)/copy-trading/out-platform-copy/create-signals/page.vue'),
                meta: {
                  topName: 'OutPlatformCopyCreateSignals',
                  hiddenInMenu: true,
                },
              },
              {
                path: 'my-publish',
                name: 'OutPlatformCopyMyPublish',
                component: () =>
                  import('@/views/(public)/copy-trading/out-platform-copy/my-publish/page.vue'),
                meta: {
                  topName: 'OutPlatformCopyMyPublish',
                  hiddenInMenu: true,
                },
              },
            ],
          },
        ],
      },
      // PAMM
      {
        path: 'pamm',
        name: '(public).pamm',
        component: () => import('@/views/(public)/pamm/layout.vue'),
        redirect: '/pamm/pamm-signal',
        children: [
          {
            path: 'pamm-signal',
            name: 'PammSignal',
            component: () => import('@/views/(public)/pamm/pamm-signal/page.vue'),
            meta: {
              hiddenInMenu: true,
              showIcon: false,
              topName: 'PammSignal',
            },
            children: [
              {
                path: 'pamm-details',
                name: 'PammSignalDetails',
                meta: {
                  topName: 'PammSignalDetails',
                },
                component: () => import('@/views/(public)/pamm/pamm-signal/pamm-detail/page.vue'),
              },
            ],
          },
          {
            path: 'pamm-assets',
            name: 'PammAssets',
            component: () => import('@/views/(public)/pamm/pamm-assets/page.vue'),
            meta: {
              hiddenInMenu: true,
              showIcon: false,
            },
          },
          {
            path: 'pamm-strategys',
            name: 'PammStrategys',
            component: () => import('@/views/(public)/pamm/pamm-strategys/page.vue'),
            meta: {
              hiddenInMenu: true,
              showIcon: false,
            },
            children: [
              {
                path: 'published-detail',
                name: 'PammPublishedDetail',
                component: () =>
                  import('@/views/(public)/pamm/pamm-strategys/published/detail/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
            ],
          },
          {
            path: 'pamm-orders',
            name: 'PammOrders',
            component: () => import('@/views/(public)/pamm/pamm-orders/page.vue'),
            meta: {
              hiddenInMenu: true,
              showIcon: false,
            },
          },
          {
            path: 'add-pamm',
            name: 'AddPamm',
            component: () => import('@/views/(public)/pamm/add-pamm/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
          },
          {
            path: 'share-recommend',
            name: 'ShareRecommend',
            component: () => import('@/views/(public)/pamm/share-recommend/page.vue'),
            meta: {
              hiddenInMenu: true,
            },
            children: [
              {
                path: 'detail',
                name: 'ShareRecommendDetail',
                component: () => import('@/views/(public)/pamm/share-recommend/detail/page.vue'),
                meta: {
                  hiddenInMenu: true,
                },
              },
            ],
          },
        ],
      },
      // 交易
      {
        path: 'trading',
        name: '(public).trading',
        component: () => import('@/views/(public)/trading/page.vue'),
        meta: {
          hiddenInMenu: true,
          sidebarCollapsed: true,
          requiresAccountData: true,
        },
      },
      // 客服中心
      {
        path: '/customer/member',
        name: '(public).customer.member',
        component: () => import('@/views/(public)/customer/page.vue'),
        meta: {
          hiddenInMenu: true,
        },
      },
    ],
  },
  // 介绍经纪人路由组
  {
    path: '/introducing-broker',
    name: 'introducing-broker',
    component: () => import('@/views/introducing-broker/layout.vue'),
    children: [
      {
        path: '',
        name: 'introducing-broker.home',
        component: () => import('@/views/introducing-broker/page.vue'),
        meta: {},
      },
      {
        path: 'my-investor',
        name: 'introducing-broker.my-investor',
        component: () => import('@/views/introducing-broker/my-investor/page.vue'),
        meta: {},
      },
      {
        path: 'agency-report',
        name: 'introducing-broker.agency-report',
        component: () => import('@/views/introducing-broker/agency-report/page.vue'),
        meta: {},
      },
      {
        path: 'transaction-reports',
        name: 'introducing-broker.transaction-reports',
        component: () => import('@/views/introducing-broker/transaction-reports/page.vue'),
        meta: {},
      },
      {
        path: 'commission-report',
        name: 'introducing-broker.commission-report',
        component: () => import('@/views/introducing-broker/commission-report/page.vue'),
        meta: {},
      },
      {
        path: 'commission-report-detail',
        name: 'introducing-broker.commission-report.detail',
        component: () => import('@/views/introducing-broker/commission-report/detail/page.vue'),
        meta: { hiddenInMenu: true },
      },
      {
        path: 'commission-details',
        name: 'introducing-broker.commission-details',
        component: () => import('@/views/introducing-broker/commission-details/page.vue'),
        meta: {},
      },
      {
        path: 'fund-details',
        name: 'introducing-broker.fund-details',
        component: () => import('@/views/introducing-broker/fund-details/page.vue'),
        meta: {},
      },
      {
        path: 'promotion-materials',
        name: 'introducing-broker.promotion-materials',
        component: () => import('@/views/introducing-broker/promotion-materials/page.vue'),
        meta: {},
      },
      {
        path: 'invitation-management',
        name: 'introducing-broker.invitation-management',
        component: () => import('@/views/introducing-broker/invitation-management/page.vue'),
        meta: {},
      },
    ],
  },
  // 用户登录页
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user/page.vue'),
    meta: { public: true },
  },
  {
    path: '/login/register',
    name: 'login.register',
    component: () => import('@/views/user/page.vue'),
    meta: { public: true },
  },
  {
    path: '/user/register',
    name: 'user.register',
    component: () => import('@/views/user/page.vue'),
    meta: { public: true },
  },
  // 客服中心--未登录
  {
    path: '/customer',
    name: '(public).customer.guest',
    component: () => import('@/views/(public)/customer/page.vue'),
    meta: {
      hiddenInMenu: true,
      public: true,
    },
  },
  // 实名结果
  {
    path: '/result',
    name: 'result',
    children: [
      {
        path: 'realname-success',
        name: 'RealnameSuccess',
        component: () => import('@/views/(public)/result/realname-success.vue'),
        meta: { public: true },
      },
      {
        path: 'realname-fail',
        name: 'RealnameFail',
        component: () => import('@/views/(public)/result/realname-fail.vue'),
        meta: { public: true },
      },
    ],
    meta: { public: true },
  },

  // 404
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/not-found/page.vue'),
    meta: { public: true },
  },

  // 重定向页
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@/views/redirect/page.vue'),
    meta: { public: true },
  },
]
